import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { combineLatest } from 'rxjs';
import { take, switchMap, map } from 'rxjs/operators';

import { ExportModalOption } from '../types/export-modal.types';
import { ExportFacade } from '../facades/export.facade';
import { ExcelWorkSheet } from '../utils/export/excel/worksheet';
import { PendoDealManagerExport } from '../state/pendo/actions';
import { ExportModalService } from './export-modal.service';
import { generateExcelWorkBook } from '../utils/export/excel/workbook';

@Injectable()
export class ExportExcelService {
  constructor(
    private readonly exportFacade: ExportFacade,
    private readonly store: Store,
    private readonly exportModalService: ExportModalService
  ) {}

  public handleExport() {
    this.exportFacade.exportOptions$
      .pipe(
        take(1),
        map(this.exportModalService.mapToExportModalOptions),
        switchMap((selectedOptions: ExportModalOption[]) => {
          return combineLatest(
            this.exportFacade.exportWorksheets(selectedOptions),
            this.exportFacade.getFilename()
          );
        })
      )
      .subscribe(([worksheets, filename]: [ExcelWorkSheet[], string]) => {
        void generateExcelWorkBook(filename, worksheets);
        this.store.dispatch(new PendoDealManagerExport());
      });
  }
}
